
export function calculateSpCost(base, increment, ranks) {
    return (ranks / 2) * (2 * base + (ranks - 1) * increment);
}

/*
export function nextRankCost(base, inc, currentRanks) {
    return base + currentRanks * inc;
}

export function deltaCost(base, inc, fromRank, toRank) {
    if (toRank < fromRank) {
        throw new Error("toRank must be greater than or equal to fromRank");
    }
    return calculateSpCost(base, inc, toRank) - calculateSpCost(base, inc, fromRank);
}
*/
